
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import DelDialog from "./delete-dialog.vue";
import { getDimensionColor } from "../../../lib/dimension/dimension-color";

import _ from "lodash-es";
@Component({
  components: { DelDialog }
})
export default class Template extends Vue {
  @Prop({}) exam!: any;

  tagColor(key: string) {
    const res = { backgroundColor: "", color: "" };
    const colorConfig = getDimensionColor(key);
    res.backgroundColor = colorConfig["background-color"];
    res.color = colorConfig["color"];
    return res;
  }

  created() {
    //
  }
  mounted() {
    const a = this.exam;
    console.log(a);
  }

  ok() {
    this.$emit("ok", this.exam.templateName);
    //
  }

  //关闭
  close() {
    this.$emit("close", false);
  }
}
